import React, { useState } from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const Intro: React.FC = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState<boolean>(false);

  const handleVideoToggle = () => {
    setIsVideoPlaying(true);
  };

  // Extract video ID from YouTube URL
  //const youtubeVideoId = 'iehVpsDNSuo';
  const youtubeVideoId = 'mZADeKlpejo';


  return (
    <Box 
      sx={{ 
        py: { xs: 6, md: 8 },
        backgroundColor: '#4682b4',
      }}
    >   
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ maxWidth: 900, width: '100%' }}>
            <Typography 
              variant="h4" 
              sx={{ 
                mb: 4, 
                fontWeight: 600,
                textAlign: 'center',
                color: '#1a1a1a',
              }}
            >
              See RiC in Action
            </Typography>
            <Paper 
              elevation={12}
              sx={{ 
                borderRadius: 3,
                overflow: 'hidden',
                boxShadow: '0 12px 40px 0 rgba(0, 0, 0, 0.15)',
                position: 'relative',
                cursor: 'pointer',
                aspectRatio: '16/9', // Maintain YouTube aspect ratio
              }}
              onClick={handleVideoToggle}
            >
              {!isVideoPlaying ? (
                <>
                   {/* Custom Poster Image */}
                 <Box
                    component="img"
                    src="/assets/riclastframe.jpg"
                    alt="Video poster"
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                  
                  {/* YouTube-style Play Button */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: 68,
                      height: 48,
                      backgroundColor: '#ff0000',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: '#cc0000',
                        transform: 'translate(-50%, -50%) scale(1.1)',
                      },
                      '&::before': {
                        content: '""',
                        width: 0,
                        height: 0,
                        borderLeft: '12px solid white',
                        borderTop: '8px solid transparent',
                        borderBottom: '8px solid transparent',
                        marginLeft: '2px',
                      },
                    }}
                  />
                </>
              ) : (
                /* YouTube Embed */
                <Box
                  component="iframe"
                  src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&rel=0&modestbranding=1&origin=${window.location.origin}`}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  sx={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                  }}
                />
              )}
            </Paper>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Intro;